import type { UsageUnitLimit } from '@shared/services/apiService/apiService';
import { USAGE_UNITS } from '@widgets/Popup/CompanyLimitsPopup/constants';

export type CompanyUsageMetricColumn = {
  headerKey: 'hours' | 'llmTokens' | 'sttHours' | 'ttsCharacters';
  unit: UsageUnitLimit;
  mode: 'hours' | 'tokens';
};

export const COMPANY_USAGE_METRIC_COLUMNS: readonly CompanyUsageMetricColumn[] = [
  { headerKey: 'hours', unit: USAGE_UNITS.callSecond, mode: 'hours' },
  { headerKey: 'llmTokens', unit: USAGE_UNITS.llmTotalTokens, mode: 'tokens' },
  { headerKey: 'sttHours', unit: USAGE_UNITS.sttSecond, mode: 'hours' },
  { headerKey: 'ttsCharacters', unit: USAGE_UNITS.ttsCharacter, mode: 'tokens' },
];
